import _ from 'lodash';
import appHelpers from 'app/app-helpers';
import lspImageTemplate from './lsp-image.html';

const CACHE_CONTROL_HEADER = 'max-age=28800, public';
const PRAGMA_HEADER = '';

@Inject('RestWrapperService', '$element', '$scope')
class LspImageController {
  constructor(restSrv, $element, $scope) {
    Object.assign(this, { restSrv, $element, $scope });
  }

  $onInit() {
    this.getCachedImage().then((response) => {
      this.$scope.$applyAsync(() => {
        this.ngModel = response;
        this.$element[0].children[0].src = response.imageUrl;
      });
    });
  }

  getCachedImage() {
    const cachedValue = _.get(this.lspImg, this.lspImgCache);
    if (cachedValue) {
      return Promise.resolve(cachedValue);
    }

    return this.loadImage().then((response) => {
      if (this.lspImgCache) {
        this.lspImgCache[this.lspImg] = response;
      }
      return Promise.resolve(response);
    });
  }

  loadImage() {
    if (this.lspImgData) {
      return Promise.resolve({
        imageUrl: URL.createObjectURL(appHelpers.b64toBlob(this.lspImgData)),
        imageData: this.lspImgData,
      });
    }

    // @TODO: for mock purposes only, remove when not needed
    if (_.find(this.lspImg, (gameImage) => gameImage.gameLogo)) {
      return this.restSrv.list(undefined, this.lspImg).then((resp) => URL.createObjectURL(appHelpers.b64toBlob(resp.img)));
    }

    return this.restSrv
      .downloadBlob(undefined, this.lspImg, null, null, {
        headers: {
          'Cache-Control': CACHE_CONTROL_HEADER,
          Pragma: PRAGMA_HEADER,
        },
      })
      .promise.then((response) => ({
        imageUrl: URL.createObjectURL(response.data),
        imageData: response.data,
      }));
  }
}

export default class LspImageComponent {
  constructor() {
    this.bindings = {
      lspImg: '=',
      lspImgData: '=',
      lspImgCache: '=',
      altImg: '@',
      cssClass: '@',
      ngModel: '=?',
    };
    this.controller = LspImageController;
    this.template = lspImageTemplate;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-image/lsp-image-component.js